// import React, { useEffect, useState } from 'react';
// import SvgIcon from '../../../Components/Common/Component/SvgIcon';
// import { CHECKALL, DeliveryComplete, DeliveryProcessing, Notification, OrderComplete, TicketsGenerated } from '../../../Constant';
// import { getNotificationList } from '../../../Services/AdminService';

// const Notificationbar = () => {
//   const [notificationDropDown, setNotificationDropDown] = useState(false);

//   const fetchNotifications = async () => {
//     const response = await getNotificationList();
//     console.log(response.data);
//   };

//   useEffect(() => {
//     fetchNotifications();
//   }, []);

//   return (
//     <li className='onhover-dropdown'>
//       <div className='notification-box' onClick={() => setNotificationDropDown(!notificationDropDown)}>
//         <SvgIcon iconId='notification' />
//         {/* <span className='badge rounded-pill badge-secondary'>4</span> */}
//       </div>
//       <div className={`notification-dropdown onhover-show-div ${notificationDropDown ? 'active' : ''}`}>
//         <h6 className='f-18 mb-0 dropdown-title'>{Notification}</h6>
//         <ul>
//           <li className='b-l-primary border-4'>
//             <p>
//               {DeliveryProcessing} <span className='font-danger'>{'10 min.'}</span>
//             </p>
//           </li>
//           <li>
//             <a className='f-w-700' href='#javascript'>
//               {CHECKALL}
//             </a>
//           </li>
//         </ul>
//       </div>
//     </li>
//   );
// };

// export default Notificationbar;
























import React, { useEffect, useState } from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import { CHECKALL, Notification } from '../../../Constant';
import { getNotificationList } from '../../../Services/AdminService';
import { useNavigate } from 'react-router-dom';

const Notificationbar = () => {
  const [notificationDropDown, setNotificationDropDown] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();

  const fetchNotifications = async () => {
    try {
      const response = await getNotificationList();
      if (response?.data) {
        setNotifications(response.data); // already sorted and limited
      }
    } catch (err) {
      console.error('Failed to fetch notifications:', err);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <li className='onhover-dropdown'>
      <div className='notification-box' onClick={() => setNotificationDropDown(!notificationDropDown)}>
        <SvgIcon iconId='notification' />
        {notifications.length > 0 && (
          <span className='badge rounded-pill badge-secondary'>{notifications.length}</span>
        )}
      </div>

      <div
        className={`notification-dropdown onhover-show-div ${notificationDropDown ? 'active' : ''}`}
        style={{ width: "400px" }}
      >
        <h6 className='f-18 mb-0 dropdown-title'>{Notification}</h6>
        <ul>
          {notifications.map((item) => (
            <li key={item._id} className='b-l-primary border-4'>
              <p>
                <strong>{item.title}</strong> - {item.body}{' '}
                <span className='font-danger'>{new Date(item.createdAt).toLocaleTimeString()}</span>
              </p>
            </li>
          ))}

          <li>
            <button
              onClick={() => navigate('/chats')}
              className='f-w-700 btn btn-link p-0'
            >
              Show All
            </button>
          </li>

          {/* <li>
            <a className='f-w-700' href='#javascript'>
              {CHECKALL}
            </a>
          </li> */}
        </ul>
      </div>
    </li>
  );
};

export default Notificationbar;
